const isCustomRangeInput = (
  input?: CustomDimensionRangeInput | FixedDimensionRangeInput,
): input is CustomDimensionRangeInput => {
  // @ts-ignore
  return input.mode === 'custom';
};

export default isCustomRangeInput;
